import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { cn } from '@mlm/ui';

/**
 * Period-over-period delta. Direction carries two signals (arrow + hue) so it
 * never relies on color alone: up reads credit-emerald, down reads
 * debit-crimson. `null` (no comparable prior period) shows a muted dash.
 */
export function DeltaChip({ deltaPct }: { deltaPct: string | null }) {
  if (deltaPct === null) {
    return null;
  }
  const n = Number(deltaPct);
  if (Number.isNaN(n)) return null;
  const up = n >= 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-caption font-medium tabular-nums',
        up ? 'text-credit' : 'text-debit',
      )}
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" />
      {up ? '+' : '−'}
      {Math.abs(n).toFixed(1)}%
      <span className="sr-only">{up ? 'up' : 'down'} versus previous period</span>
    </span>
  );
}
